import { render, staticRenderFns } from "./headerCheckBox.vue?vue&type=template&id=2b4b5ee0"
import script from "./headerCheckBox.vue?vue&type=script&lang=js"
export * from "./headerCheckBox.vue?vue&type=script&lang=js"
import style0 from "./headerCheckBox.vue?vue&type=style&index=0&id=2b4b5ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports